// @ts-check

import { useMemo } from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { combineBranding } from "../utils";
import { useOrgBrandingForTenant } from "./useOrgBrandingForTenant";
import { useOrgBrandingForWorkspace } from "./useOrgBrandingForWorkspace";

/**
 * Hook for getting branding to show in UI.
 */
export const useOrgBranding = () => {
  const { loading: loadingTenant, branding: tenantBranding } =
    useOrgBrandingForTenant();
  const { loading: loadingWorkspace, branding: workspaceBranding } =
    useOrgBrandingForWorkspace();
  // TODO: replace with org feature flags when ready
  const workspaceFeatureFlags = useWorkspaceFeatureFlags();

  const branding = useMemo(
    /**
     * @returns {org_config.tenant.Branding & org_config.workspace.Branding}
     */
    () => {
      return combineBranding({
        ...(tenantBranding ? { tenantBranding } : {}),
        ...(workspaceFeatureFlags?.enableWorkspaceSettings && workspaceBranding
          ? { workspaceBranding }
          : {}),
      });
    },
    [tenantBranding, workspaceBranding, workspaceFeatureFlags]
  );

  return {
    loading: loadingTenant || loadingWorkspace,
    branding,
  };
};
